import React from 'react';

import Input from 'airbnb-dls-web/build/exp/Input';

export default class UncontrolledInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    this.setState({ value });
  }

  render() {
    const { value } = this.state;

    return <Input {...this.props} value={value} onChange={this.onChange} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/UncontrolledInput.jsx